export const desktopSeparator = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="74"
    viewBox="0 0 25 74"
    fill="none"
  >
    <path d="M1 1L23.5 38L1 73" stroke="#E4E4E4" />
  </svg>
);

export const mobileSeparator = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="4"
    height="14"
    viewBox="0 0 4 14"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.4872 0.500001C3.75627 0.562094 3.92406 0.830555 3.86197 1.09963L1.08683 13.1252C1.02473 13.3943 0.756271 13.5621 0.4872 13.5C0.218129 13.4379 0.0503411 13.1694 0.112434 12.9004L2.88757 0.874767C2.94967 0.605696 3.21813 0.437908 3.4872 0.500001Z"
      fill="#E4E4E4"
    />
  </svg>
);
